import React from 'react';
import ErrorMessageDropdown from 'app/components/base/ErrorMessageDropdown';
import DesktopAutocomplete from 'app/components/base/BaseAutocomplete/Desktop';
import MobileAutocomplete from 'app/components/base/BaseAutocomplete/Mobile';

/**
 * Wrapped Autocomplete component which can display validation messages
 */
export const WrappedAutocomplete = (props) => {
  return (
    <ErrorMessageDropdown {...props}>
      {props.mobile ? (
        <MobileAutocomplete {...props} rectangled />
      ) : (
        <DesktopAutocomplete {...props} rectangled />
      )}
    </ErrorMessageDropdown>
  );
};

// TODO: move to Flow types
// WrappedAutocomplete.propTypes = {
//   meta: PropTypes.object,
//   mobile: PropTypes.bool
// };

export default WrappedAutocomplete;
